import * as action_types from "./constants";
import {
  DriveTimeResponse,
  ScheduleDataType,
  SchedulingFiltersResponse,
  SchedulingFormDataResponse,
} from "./types";

export type myCompanyState = {
  driveTimeData: {
    data: DriveTimeResponse | null;
    loading: boolean;
  };
  schedulingFiltersData: {
    data: SchedulingFiltersResponse | null;
    loading?: boolean;
  };
  schedulingFormData: {
    data: SchedulingFormDataResponse | null;
    loading: boolean;
  };
  schedulingData: {
    data: ScheduleDataType[] | null;
    loading?: boolean;
  };
  schedulingWeekData?: {
    data: ScheduleDataType[] | null;
    loading?: boolean;
  };
  weatherWeekData: {
    data: [] | null;
    loading?: boolean;
  };
};

const initialState: myCompanyState = {
  driveTimeData: {
    data: null,
    loading: false,
  },
  schedulingFiltersData: {
    data: null,
    loading: true,
  },
  schedulingFormData: {
    data: null,
    loading: true,
  },
  schedulingData: {
    data: null,
    loading: true,
  },
  schedulingWeekData: {
    data: null,
    loading: true,
  },
  weatherWeekData: {
    data: null,
    loading: true,
  },
};

type MyCompanyActionType =
  | {
      type: typeof action_types.GET_DRIVE_TIME;
      data: {
        payload: DriveTimeResponse | null;
        loading: boolean;
      };
    }
  | {
      type: typeof action_types.SCHEDULING_FILTERS;
      data: {
        payload: SchedulingFiltersResponse | null;
        loading?: boolean;
      };
    }
  | {
      type: typeof action_types.GET_SCHEDULING_FORM_DATA;
      data: {
        payload: SchedulingFormDataResponse | null;
        loading: boolean;
      };
    }
  | {
      type: typeof action_types.GET_SCHEDULE_BY_DAY;
      data: {
        payload: ScheduleDataType[] | null;
        loading?: boolean;
      };
    }
  | {
      type: typeof action_types.GET_SCHEDULE_BY_WEEK;
      data: {
        payload: ScheduleDataType[] | null;
        loading?: boolean;
      };
    }
  | {
      type: typeof action_types.GET_WEATHER_BY_WEEK;
      data: {
        payload: [] | null;
        loading?: boolean;
      };
    };

const myCompanyReducer = (
  state = initialState,
  action: MyCompanyActionType
): myCompanyState => {
  const { type, data } = action;
  switch (type) {
    case action_types.GET_DRIVE_TIME:
      return {
        ...state,
        driveTimeData: {
          data: data.payload,
          loading: data.loading,
        },
      };

    case action_types.SCHEDULING_FILTERS:
      return {
        ...state,
        schedulingFiltersData: { data: data?.payload, loading: data?.loading },
      };

    case action_types.GET_SCHEDULING_FORM_DATA:
      return {
        ...state,
        schedulingFormData: { data: data?.payload, loading: data?.loading },
      };

    case action_types.GET_SCHEDULE_BY_DAY:
      return {
        ...state,
        schedulingData: { data: data?.payload, loading: data?.loading },
      };

    case action_types.GET_SCHEDULE_BY_WEEK:
      return {
        ...state,
        schedulingWeekData: { data: data?.payload, loading: data?.loading },
      };

    case action_types.GET_WEATHER_BY_WEEK:
      return {
        ...state,
        weatherWeekData: { data: data?.payload, loading: data?.loading },
      };

    default:
      return state;
  }
};

export default myCompanyReducer;
